/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StripeService {
    /**
     * Connect a Stripe account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully connected a Stripe account
     * @throws ApiError
     */
    public static postStripe(
        workspaceId: string,
        requestBody: {
            code: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List connected Stripe accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List connected Stripe accounts
     * @throws ApiError
     */
    public static getStripe(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/stripe',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Disconnect a Stripe account
     * @param id The id of api key
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully disconnected a Stripe account
     * @throws ApiError
     */
    public static deleteStripe(
        id: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/stripe/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Capture events for a Stripe account
     * @param requestBody
     * @returns any Successfully captured event
     * @throws ApiError
     */
    public static postStripeEvents(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe/events',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
